import React from 'react';
import { EmptyState } from 'system/atoms/empty-states/EmptyState';
import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';

interface CandidateProfileEmptyStateProps {
  candidateProfileListProps: CandidateProfileListProps;
  integrationProvider: string;
  isFiltering: boolean;
}

const isTalentPoolList = (type: CandidateProfileListType): boolean => {
  return (
    type === CandidateProfileListType.CANDIDATES_FROM_TALENT_POOL ||
    type === CandidateProfileListType.ANALYSIS_CANDIDATES_FROM_TALENT_POOL
  );
};

export const CandidateProfileEmptyState: React.FC<
  CandidateProfileEmptyStateProps
> = ({ candidateProfileListProps, integrationProvider, isFiltering }) => {
  if (isTalentPoolList(candidateProfileListProps.type)) {
    if (isFiltering) {
      return (
        <EmptyState
          type="no-results"
          title="No candidates found"
          subtitle="Try adjusting your search or filters"
        />
      );
    }

    return <EmptyState type="no-records" title="No candidates to show" />;
  }

  if (isFiltering) {
    return (
      <EmptyState
        type="no-results"
        title="No candidates found"
        subtitle={`Try adjusting your search or filters to find candidates in ${integrationProvider}`}
      />
    );
  }

  return <EmptyState type="no-records" title="No candidates to show" />;
};
